import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, deleteDoc, getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { Button, Table, Container } from "react-bootstrap";
import * as XLSX from 'xlsx'; // Import the xlsx library
import './EmployeeList.css';
import { writeBatch } from "firebase/firestore";

const EmployeeList = ({ employees }) => {
  const [employeeSoftware, setEmployeeSoftware] = useState({}); // State to map employee IDs to software names

  // Fetch licenses from Firestore
  useEffect(() => {
    const fetchLicenses = async () => {
      const querySnapshot = await getDocs(collection(db, "licenses"));
      const licensesData = querySnapshot.docs.map((doc) => doc.data());

      // Create a map of employee ID to software names
      const employeeSoftwareMap = {};
      employees.forEach((employee) => {
        const softwareAssigned = licensesData
          .filter((license) => license.seat_assignment.includes(employee.id)) // Filter licenses where employee is assigned
          .map((license) => license.software_name); // Get the software names for the employee
        employeeSoftwareMap[employee.id] = softwareAssigned;
      });
      setEmployeeSoftware(employeeSoftwareMap);
    };
    fetchLicenses();
  }, [employees]);

  const handleDelete = async (id) => {
    try {
      // Initialize batch operation
      const batch = writeBatch(db);
  
      // Fetch all licenses
      const licensesSnapshot = await getDocs(collection(db, "licenses"));
  
      licensesSnapshot.forEach((licenseDoc) => {
        const licenseData = licenseDoc.data();
  
        if (licenseData.seat_assignment && licenseData.seat_assignment.includes(id)) {
          // Remove the employee from the seat_assignment array
          const updatedSeatAssignment = licenseData.seat_assignment.filter(empId => empId !== id);
  
          // Update the Firestore document
          batch.update(licenseDoc.ref, { seat_assignment: updatedSeatAssignment });
        }
      });
  
      // Commit the batch update
      await batch.commit();
  
      // Delete the employee
      await deleteDoc(doc(db, "employees", id));
  
      alert("Employee and their software assignments deleted successfully!");
    } catch (error) {
      console.error("Error deleting employee:", error);
      alert("Error deleting employee. Please try again.");
    }
  };

  // Export table data to Excel
  const handleExport = () => {
    const data = employees.map((employee) => {
      return {
        'שם מלא': employee.full_name,
        'אימייל': employee.email,
        'תוכנות משויכות': employeeSoftware[employee.id]
          ? employeeSoftware[employee.id].join(", ")
          : 'אין תוכנות משויכות'
      };
    });

    // Create a new workbook and add the data as a worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees");

    // Generate Excel file and prompt for download
    XLSX.writeFile(wb, "employees.xlsx");
  };

  return (
    <Container className="employee-list">
      
      <h2 className="mb-3">עובדים</h2>
      <div className="top-list-buttons">  
      <Link to="/add-employee" className="btn btn-primary mb-3">
        הוסף עובד חדש
      </Link>
      <Button variant="success" className="mb-3" onClick={handleExport}>
      ייצוא ל-Excel
      </Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr className="employee-list-header">
            <th>שם מלא</th>
            <th>אימייל</th>
            <th>תוכנות משויכות</th>
            <th>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => (
            <tr key={employee.id}>
              <td>{employee.full_name}</td>
              <td>{employee.email}</td>
              <td>
                {/* Display the software names assigned to the employee */}
                {employeeSoftware[employee.id] && employeeSoftware[employee.id].length > 0 ? (
                  <ul style={{ listStyleType: 'disc', paddingRight: '20px' }}>
                    {employeeSoftware[employee.id].map((software, index) => (
                      <li key={index}>{software}</li>
                    ))}
                  </ul>
                ) : (
                  <span>אין תוכנות משויכות</span>
                )}
              </td>
              <td>
                <Link to={`/dashboard/edit-employee/${employee.id}`} className="btn btn-warning btn-sm me-2">
                  ערוך
                </Link>
                <Button variant="danger" size="sm" onClick={() => handleDelete(employee.id)}>
                  מחק
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default EmployeeList;
